var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "embed-content",
      attrs: { id: _vm.id },
      on: { mousedown: _vm.focus, touchstart: _vm.focus }
    },
    [
      _c("div", { staticClass: "embed-content__handle tooltip-drag-handle" }, [
        _vm._v("::::::")
      ]),
      _vm._v(" "),
      _vm.content
        ? _c("div", {
            staticClass: "embed-content__content",
            class: { "embed-content__content--focused": _vm.hasFocus },
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        : _c(
            "div",
            {
              staticClass:
                "embed-content__content embed-content__content--empty",
              class: { "embed-content__content--focused": _vm.hasFocus },
              on: { click: _vm.showEditor }
            },
            [_vm._v("クリックしてコードを編集\n  ")]
          ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "menu-effect" } }, [
        _vm.hasFocus
          ? _c("div", { staticClass: "menu-container" }, [
              _c("ul", { staticClass: "menu-container__item" }, [
                _c(
                  "li",
                  {
                    staticClass: "menu-button tooltip-edit-content",
                    on: { click: _vm.showEditor }
                  },
                  [_c("span", { staticClass: "fi-pencil" })]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "overlay-transition" } }, [
        _vm.isEditorVisible
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "escape-key",
                    rawName: "v-escape-key",
                    value: _vm.hideEditor,
                    expression: "hideEditor"
                  }
                ],
                staticClass: "overlay-background",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.hideEditor($event)
                  }
                }
              },
              [
                _c("embed-editor", {
                  staticClass: "embed-editor reveal",
                  attrs: { value: _vm.content },
                  on: {
                    input: _vm.trackInputEmbedText,
                    submit: _vm.saveContent,
                    close: _vm.trackClose
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "embed-content__delete tooltip-delete",
            on: {
              click: function($event) {
                _vm.deleteComponent()
              }
            }
          },
          [_vm._v("×\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm.isMaskVisible
        ? _c("div", { staticClass: "embed-content__mask" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }